"use client";


import "react-datepicker/dist/react-datepicker.css";

import dayjs, { Dayjs } from "dayjs";
import AdvancedFormat from "dayjs/plugin/advancedFormat";
import {
  FC,
  LegacyRef,
  forwardRef,
  MouseEvent,
} from "react";
import DatePicker from "react-datepicker";
import { CalendarIcon } from "@heroicons/react/24/outline";

import { Button } from "../Button/Button";
import { PropsWithTestId } from "../types";

interface Props extends PropsWithTestId {
  value?: Dayjs;
  onChange(value: Dayjs): void;
  placeholder: string;
  minDate?: Dayjs;
  filter?: (value: Dayjs) => boolean;
}

interface PickerButtonProps extends Pick<Props, | "placeholder">, PropsWithTestId {
  onClick: (event: MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  value: Dayjs | undefined;
}

const DatePickerButtonIcon: FC<{ value?: Dayjs; }> = ({ value }) => (
  <CalendarIcon width={ 20 } color={ value ? "white" : "black" } className="mr-1" />
);

// This is pretty inefficient, but the only way to get around
// the library's API
const DatePickerButton = forwardRef(({
  onClick,
  value,
  placeholder,
  "data-testid": dataTestId,
}: PickerButtonProps, ref: LegacyRef<HTMLButtonElement>) => (
  <Button
    data-component={ DatePickerButton.name }
    data-testid={ dataTestId }
    ref={ ref }
    variant={ value ? "primary" : "tertiary" }
    Icon={DatePickerButtonIcon}
    // @ts-ignore
    onClick={ onClick }
  >
    { value ? dayjs(value).format("dddd Do MMM 'YY") : placeholder }
  </Button>
));

dayjs.extend(AdvancedFormat);

export const DateInput: FC<Props> = ({
  value,
  onChange,
  placeholder,
  minDate,
  filter,
}) => (
  // @ts-ignore
  <DatePicker
    minDate={minDate ? minDate.toDate() : undefined}
    selected={value?.toDate()}
    onChange={(newDate: Date | null) => newDate && onChange(dayjs(newDate))}
    dateFormat={"yyyy MM d"}
    // @ts-ignore
    customInput={ <DatePickerButton placeholder={ placeholder } />}
    filterDate={filter === undefined
      ? undefined
      : (d: Date) => filter(dayjs(d))
    }
  />
);
